import { IIconProps } from '@fluentui/react';
import { IPSharedColors } from "themes/runtime/fluentColors";

export const SkypeCircleCheckIcon: IIconProps = {
  iconName: 'SkypeCircleCheck',
  styles: {
    root: {
      fontSize: 20,
      color: IPSharedColors.green20,
      selectors: {
        '&:hover': {
          color: IPSharedColors.green10,
        },
      },
    },
  },
};

export const StatusErrorFullIcon: IIconProps = {
  iconName: 'StatusErrorFull',
  styles: {
    root: {
      fontSize: 20,
      color: IPSharedColors.red20,
      selectors: {
        '&:hover': {
          color: IPSharedColors.red10,
        },
      },
    },
  },
};

export const CircleRingIcon: IIconProps = {
  iconName: 'CircleRing',
  styles: {
    root: {
      fontSize: 20,
      color: IPSharedColors.gray20,
      selectors: {
        '&:hover': {
          color: IPSharedColors.gray10,
        },
      },
    },
  },
};

export const SkypeCircleClock: IIconProps = {
  iconName: 'SkypeCircleClock',
  styles: {
    root: {
      fontSize: 20,
      color: IPSharedColors.gray20,
      selectors: {
        '&:hover': {
          color: IPSharedColors.gray10,
        },
      },
    },
  },
};

export const NavigateForwardIcon: IIconProps = {
  iconName: 'NavigateForward',
  styles: {
    root: {
      fontSize: 22,
      color: IPSharedColors.yellow10,
    },
  },
};

export const CallOutRowStyle = {
  root: {
    cursor: 'pointer',
    selectors: {
      '&:hover': {
        color: IPSharedColors.gray20,
      },
    },
  },
};
